const parsePositiveInt = (value, fallback = 0) => {
  const next = Number(value);
  if (!Number.isFinite(next)) return fallback;
  return Math.max(0, Math.trunc(next));
};

const inferTicketsPerUnitFromText = (...sources) => {
  const patterns = [
    /(^|\n|\r)\s*(\d+)\s*entradas?\b/i,
    /\bmesa(?:s)?\s+para\s+(\d+)\b/i,
    /\b(\d+)\s*personas?\b/i,
  ];

  for (const source of sources) {
    const text = String(source || "").trim();
    if (!text) continue;
    for (const pattern of patterns) {
      const match = text.match(pattern);
      const rawValue = match?.[2] ?? match?.[1];
      const inferred = parsePositiveInt(rawValue, 0);
      if (inferred > 0) return inferred;
    }
  }

  return 0;
};

export const resolveTicketsPerUnit = (ticket, fallback = 1) => {
  const source = ticket || {};
  const explicit =
    source.ticketsPerUnit ??
    source.issuedTickets ??
    source.entriesIncluded ??
    source.admissionsIncluded ??
    source.accessCount ??
    source.peopleCount ??
    source.partySize;
  const next = parsePositiveInt(explicit, 0);
  if (next > 0) return next;

  const inferred = inferTicketsPerUnitFromText(
    source.description,
    source.ticketTypeDescription,
    source.ticketTypeName,
    source.tickettypename,
    source.name
  );
  if (inferred > 0) return inferred;

  const safeFallback = parsePositiveInt(fallback, 0);
  return safeFallback > 0 ? safeFallback : 1;
};
